import React from "react";
import { NavLink } from "react-router-dom";
import TflBanner from "./../../../assets/TFL_banner.png";
import { Card, Row, Col, Button, Image, Container } from "react-bootstrap";
import Home from "./../../Home";
const TflReport = (props) => {
  let tflamount = Number(localStorage.getItem("tflamount"));
  return (
    <>
      <Home>
        <div className="report-container">
          <span className="item ">
            <span>Arkiv : </span> TFL RAPPORT
            <NavLink to="/arkiv" className="btn back-btn">
              <i className="fa fa-arrow-circle-left" aria-hidden="true" />
            </NavLink>
          </span>
        </div>
        <Card className="mt-5">
          <Card.Body>
            <Row>
              <Col>
                <Image src={TflBanner} alt="Tfl Banner" />
                <Row className="text-center">
                  <Col>
                    {" "}
                    <h2 style={{ color: "green", fontWeight: "bold" }}>
                      TFL AMOUNT:{`Kr.${tflamount}`}
                    </h2>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Home>
    </>
  );
};

export default TflReport;
